<template>
    <div>
        <b-card v-if="!item.is_moral" no-body class="shadow-sm mb-3">
            <b-card-body>
                <p class="mb-1 small font-weight-bold text-uppercase">
                    {{ item.title }}
                </p>
                <physical-person-data :data="item" :editable="false" />
                <b-button
                    variant="primary"
                    size="sm"
                    @click="storePhysicalAuditor"
                >
                    <i class="fas fa-arrow-alt-left fa-fw"></i> Affecter
                </b-button>
            </b-card-body>
        </b-card>

        <b-card v-else no-body class="shadow-sm mb-3">
            <b-card-body>
                <p class="mb-1 small font-weight-bold text-uppercase">
                    {{ item.title }}
                </p>
                <moral-person-data :data="item" />
                <b-button
                    variant="primary"
                    size="sm"
                    @click="storeMoralAuditor"
                >
                    <i class="fas fa-arrow-alt-left fa-fw"></i> Affecter
                </b-button>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PhysicalPersonData from '../physicalPersons/PhysicalPersonData'
import MoralPersonData from '../moralPersons/MoralPersonData'

export default {
    name: 'PappersAuditor',

    components: {
        MoralPersonData,
        PhysicalPersonData,
    },

    props: {
        item: null,
        company: null,
    },

    data() {
        return {
            form: {},
        }
    },

    created() {
        this.form.client_id = this.company.id
        this.form.person = this.item
    },

    methods: {
        async storePhysicalAuditor() {
            try {
                await axios.post('/auditors/physicalPersons/pappers', this.form)
                this.$emit('auditor-is-stored')
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                console.log(error)
            }
        },

        async storeMoralAuditor() {
            try {
                await axios.post('/auditors/moralPersons/pappers', this.form)
                this.$emit('auditor-is-stored')
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
